<template>
  <div class="register-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page account-select-page section-image" filter-color="black">
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-6 ml-auto mr-auto">
                <!-- Account selection -->
                <card type="lock" :footer-line="true">
                  <div class="panel-body">
                    <div v-if="loading" class="spinner-container">
                      <double-bounce size="60px"></double-bounce>
                    </div>

                    <div v-if="!loading && accounts.length > 0 && !showCreateAccountForm">
                      <h2>Select an account:</h2>
                      <div class="list-group">
                        <button
                          type="button"
                          @click="selectAccount(account)"
                          v-for="account in accounts"
                          v-bind:key="account.id"
                          class="list-group-item list-group-item-action clickable"
                        >{{ account.name }}</button>
                      </div>
                      <div class="spacer"></div>
                      <!-- Select an account -->
                      <!-- Button to show "create new account" form -->
                      <p slot="footer" class="text-muted small">
                        You can also
                        <a
                          href="#"
                          @click="showCreateAccountForm = true"
                        >create a new account</a>.
                      </p>
                    </div>

                    <div v-if="!loading && showCreateAccountForm">
                      <!-- Create account form -->
                      <h2>Create an account</h2>
                      <p v-if="accounts.length > 0" class="text-muted small">
                        You can also
                        <a
                          href="#"
                          @click="showCreateAccountForm = false"
                        >select an existing account</a>.
                      </p>
                      <form>
                        <fg-input
                          type="text"
                          name="name"
                          data-vv-as="name"
                          data-vv-delay="1000"
                          label="Name"
                          placeholder="Your Business Name"
                          v-model="form.name"
                          v-validate="formValidators.name"
                          :error="fieldError('name')"
                        ></fg-input>
                      </form>
                      <div class="text-right">
                        <p-button
                          type="submit"
                          @click="validate"
                          :disabled="creating"
                          class="btn btn-success"
                        >
                          <span v-if="!creating">
                            Get started &nbsp;
                            <i class="fa fa-arrow-right"></i>
                          </span>
                          <span v-if="creating">
                            <i class="fa fa-spin fa-circle-o-notch"></i>&nbsp;
                            Please wait&hellip;
                          </span>
                        </p-button>
                      </div>
                      <p
                        slot="footer"
                        class="text-muted small"
                      >If you think your team already has an account, ask your administrator to invite you using your email address ({{ $auth.user().email.address }}).</p>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background: #F7971E; background: -webkit-linear-gradient(to left, #FFD200, #F7971E); background: linear-gradient(to left, #FFD200, #F7971E);"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { DoubleBounce } from "vue-loading-spinner";

import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import {
  Card,
  Checkbox,
  Button,
  InfoSection
} from "src/components/UIComponents";

export default {
  components: {
    Card,
    AppNavbar,
    DoubleBounce,
    AppFooter,
    InfoSection,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  data() {
    return {
      form: {
        name: ""
      },
      formValidators: {
        name: {
          required: true,
          min: 3
        }
      },
      validationErrors: {},
      errorMessage: null,
      creating: false,
      loading: false,
      accounts: [],
      showCreateAccountForm: false,
      loadingError: false
    };
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
        if (isValid) {
          this.createAccount();
        }
      });
    },
    selectAccount(account) {
      // set to local storage
      this.$ls.set("account", account);

      // go to account dashboard
      this.$router.push("/account");
    },
    createAccount() {
      this.creating = true;
      const body = {
        name: this.form.name
      };

      this.axios
        .post("/v1/accounts", body)
        .then(response => {
          this.creating = false;

          // set to local storage
          this.$ls.set("account", response.data);

          // go to account dashboard
          this.$router.push("/account");
        })
        .catch(error => {
          this.creating = false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.data.message) {
              this.errorMessage = error.response.data.message;

              if (error.response.status === 400 && error.response.data.errors) {
                this.validationErrors = error.response.data.errors;
              }
            } else {
              this.errorMessage = "Sorry, an unknown error occurred.";
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest
            this.errorMessage = "Error - no response from server.";
          } else {
            // Something happened in setting up the request that triggered an Error
            this.errorMessage = "Error - request not sent";
          }
        });
    },
    fieldError(fieldName) {
      // clientside
      if (this.errors.first(fieldName)) {
        return this.errors.first(fieldName);
      }

      // serverside
      const fieldError = _.find(this.validationErrors, item => {
        return _.includes(item.field, fieldName);
      });

      if (!fieldError) {
        return false;
      } else if (fieldError.messages) {
        return fieldError.messages;
      } else {
        return true;
      }
    }
  },
  beforeMount() {
    this.loading = true;
    this.axios
      .get("/v1/accounts")
      .then(response => {
        this.loading = false;
        this.accounts = response.data;
        if (this.accounts.length < 1) {
          this.showCreateAccountForm = true;
        }
      })
      .catch(error => {
        this.loading = false;
        this.loadingError = "Failed to load accounts";
      });
  },
  beforeDestroy() {
    this.closeMenu();
  }
};
</script>
<style>
</style>
